import { useMemo } from "react";

import { PollingIntervalGroups } from "apollo/constants";
import usePolledQuery from "apollo/usePolledQuery";
import { AiChatSession } from "components/AiChat/types";

import { CHAT_CONVERSATIONS } from "./gql";

type UseSearchChatConversationsOptions = {
  shouldPoll?: () => boolean;
};

const useSearchChatConversations = ({ shouldPoll }: UseSearchChatConversationsOptions = {}) => {
  const { data, loading, error, refetch, previousData } = usePolledQuery(CHAT_CONVERSATIONS, {
    fetchPolicy: "cache-and-network",
    pollingGroup: PollingIntervalGroups.Lists,
    shouldPoll,
  });

  const cachedConversations = useMemo(() => {
    return data?.intentChatConversations || previousData?.intentChatConversations || [];
  }, [data, previousData]);

  const conversations = useMemo<AiChatSession[]>(() => {
    return cachedConversations.map((conversation) => ({
      id: conversation.id,
      name: conversation.description || "New Chat",
      updatedAt: conversation.updatedAt,
    }));
  }, [cachedConversations]);

  return {
    conversations,
    loading,
    error,
    refetch,
  };
};

export default useSearchChatConversations;
